import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportSummaryComponent } from './report-summary.component';
import { VerificationStatusModule } from "../../components/verification-status/verification-status.module";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';


@NgModule({
  declarations: [ReportSummaryComponent],
  imports: [
    CommonModule,
    VerificationStatusModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
  ],
  exports: [
    ReportSummaryComponent
  ]
})
export class ReportSummaryModule { }
